var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66683 0.666748H2.3335C1.22683 0.666748 0.333496 1.56008 0.333496 2.66675V13.3334C0.333496 14.4401 1.22683 15.3334 2.3335 15.3334H7.66683C8.7735 15.3334 9.66683 14.4401 9.66683 13.3334V2.66675C9.66683 1.56008 8.7735 0.666748 7.66683 0.666748ZM6.3335 14.0001H3.66683V13.3334H6.3335V14.0001ZM8.50016 12.0001H1.50016V2.66675H8.50016V12.0001Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b4c58bc56ca8b3f5fa5d33b94e33fc12.svg";
export { ForwardRef as ReactComponent };